import type { AwaitingActivationList } from "@care-by-ella/contracts";
import { API_BASE, apiFetch, withCredentials } from "./api";
import { commonHeaders, jsonOr401 } from "./clinician-api";

// TES-1150 — "Recept utfärdat – inväntar abonnemangsaktivering", admin only.
// The API logs every patient it returns as a read on the support basis; PDL
// purpose: administration.

const BASE = `${API_BASE}/employee-api/v1/onboarding-funnel/awaiting-activation`;

export async function fetchAwaitingActivation(): Promise<AwaitingActivationList> {
  const res = await apiFetch(BASE, {
    headers: { ...commonHeaders(), "X-Access-Purpose": "administration" },
    ...withCredentials,
  });
  return jsonOr401(res);
}
